import { BackendHttpService } from "../backendHttpService";

interface InternalCustomerResponse {
    id: number | null;
    isInternal: boolean;
    name: string;
}

export class InternalCustomerDictionaryService extends BackendHttpService {
    private customersCache: string[] | null = null;

    constructor() {
        super("internal-customer");
    }

    async getCustomerNames(): Promise<string[]> {
        if (this.customersCache) {
            return this.customersCache;
        }
        try {
            const customers = await this.get<InternalCustomerResponse[]>("");
            this.customersCache = Array.from(new Set(
                customers
                    .map((c) => c.name?.trim())
                    .filter((n): n is string => !!n)
                    .sort((a, b) => a.localeCompare(b))
            ));
            return this.customersCache;
        } catch (error) {
            console.error("Error getting internal customers dictionary:", error);
            throw error;
        }
    }

    clearCache(): void {
        this.customersCache = null;
    }
}

export const internalCustomerDictionaryService =
    new InternalCustomerDictionaryService();
